// Getters
export const SESS_IS_ERROR = 'sessions/stateSessIsError';
export const SESS_IS_LOADING = 'sessions/stateSessIsLoading';
export const SESS_GET_DATA = 'sessions/stateSessData';
export const SESS_GET_FILTER = 'sessions/stateSessFilter';
export const SESS_GET_MANY_RECORDS_ALERT = 'sessions/stateSessGetManyRecordsAlert';

// Actions
// export const SESS_ACTION_DATA = 'sessions/stateSessData';
export const SESS_ACTION_FILTER = 'sessions/stateSessActionSearchByFilter';
export const SESS_ACTION_TABLE_REF = 'sessions/stateSessActionTableRef';
export const SESS_ACTION_MANY_RECORDS_ALERT = 'sessions/stateSessActionTooManyRecordsAlert';



// WEBPACK FOOTER //
// ./src/store/types_sessions.js